import { render, staticRenderFns } from "./Guides.vue?vue&type=template&id=846b7876&"
import script from "./Guides.vue?vue&type=script&lang=js&"
export * from "./Guides.vue?vue&type=script&lang=js&"
import style0 from "./Guides.vue?vue&type=style&index=0&id=846b7876&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports